/**
 * @changelog
 *
 * 2026-04-09 (0.1.0) (jhoward)
 *   - Add new function isOfferForLinkedAccount to detect if an offer is for a linked account.
 */

import type { OpcOffer } from '@/defs/api/OpcOffer';
import useAppStore from '@/store';

export default function isOfferForLinkedAccount(offer: OpcOffer): boolean {
  const appStore = useAppStore();
  if (!appStore.state.user) {
    return false;
  }

  return offer.CASINO_PATRON_ID !== appStore.state.user.account_id;
}
